import React, { memo, useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FaCalendarAlt, FaArrowRight } from 'react-icons/fa';
import '../assets/css/recentpost.css';

export const RecentPostCard = memo(({ post }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 

  return (
    <Col xs={12} sm={6} md={4} className="mb-4">
      <Link
        to={`/description/${post.subCategory}/${post.slug}`}
        className="recent-post-card-link"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <div className="recent-post-card">
          <div className="recent-post-body">
            <div>
              <span className="recent-post-category">{post.subCategory}</span>
              <h5 className="recent-post-title">{post.topic}</h5>
            </div>
            
            <div className="recent-post-meta">
              <div className="recent-post-date">
                <FaCalendarAlt className="recent-post-date-icon" />
                {post.timestamp ? new Date(post.timestamp).toLocaleDateString() : 'No date'}
              </div>
              <span className="recent-post-action">
                Read <FaArrowRight className="recent-post-action-icon" />
              </span>
            </div>
          </div>
        </div>
      </Link>
    </Col>
  );
});

RecentPostCard.propTypes = {
  post: PropTypes.shape({
    topic: PropTypes.string.isRequired,
    subCategory: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    timestamp: PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      PropTypes.object
    ]),
  }).isRequired,
};

export const RecentPostsSection = memo(({ recentPosts, loading, error }) => {
  if (loading) {
    return (
      <div 
        className="d-flex justify-content-center align-items-center w-100" 
        style={{ minHeight: '200px', margin: '0 auto' }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }

  return (
    <div className="row justify-content-center mt-4">
      {recentPosts.length > 0 ? (
        recentPosts.map((post, index) => (
          <RecentPostCard key={index} post={post} />
        ))
      ) : (
        <div className="col-12 text-center">
          <p className="text-muted">No recent posts available.</p>
        </div>
      )}
    </div>
  );
});

RecentPostsSection.propTypes = {
  recentPosts: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
};